import { isUndefined } from 'lodash';
import { PROGRAM_CONFIG } from 'utils/constants';
import Program from 'utils/program';
import { Config } from 'utils/config/config';

interface IDefaultHeaderType {
  Accept: string;
  'Content-Type': string;
  Program?: string;
}

export const MAMI_SERVER_VERSION_2 = 'v2';
export const MAMI_SERVER_V2 = () =>
  `${Config.MAMI_URL}/api/${MAMI_SERVER_VERSION_2}`;

export const apiUrl = (path: string): string => `${Config.PAPI_URL}/${path}`;

export const apiUrlForRequiredAuth = (path: string): string => {
  // if (API_GATEWAY_URL) return `${API_GATEWAY_URL}/papi-private/${path}`;
  return apiUrl(path);
};

export const isNetworkOffline = (): boolean => !window.navigator.onLine;

export const isJsonString = (jsonString: any): boolean => {
  try {
    JSON.parse(jsonString);
  } catch (e) {
    return false;
  }
  return true;
};

export const getDefaultHeaders = (): IDefaultHeaderType => {
  const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
  };

  const program = Program.get()?.name;
  if (isUndefined(program)) return { ...defaultHeaders };

  return {
    ...defaultHeaders,
    Program: PROGRAM_CONFIG[program]?.header || program,
  };
};
